<template>
  <div class="white-block">
    <slot></slot>
  </div>
</template>

<script setup></script>

<style lang="scss" scoped>
//НЕ ИЗМЕНЯТЬ! ЭТО ДЛЯ МОДУЛЯ PORTAL
.white-block {
  background: #ffffff;
}
</style>
